import { render, staticRenderFns } from "./BasicElementsSection.vue?vue&type=template&id=3c98a925"
import script from "./BasicElementsSection.vue?vue&type=script&lang=js"
export * from "./BasicElementsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports